// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2_2LV","title":"InfoRow_title__328zY"};